/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientOverviewResource } from './';
import {
    ClientOverviewResourceFromJSON,
    ClientOverviewResourceFromJSONTyped,
    ClientOverviewResourceToJSON,
} from './';
import type { ClientProjectType } from './';
import {
    ClientProjectTypeFromJSON,
    ClientProjectTypeFromJSONTyped,
    ClientProjectTypeToJSON,
} from './';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { FreelancerOverviewResource } from './';
import {
    FreelancerOverviewResourceFromJSON,
    FreelancerOverviewResourceFromJSONTyped,
    FreelancerOverviewResourceToJSON,
} from './';
import type { ManagersResource } from './';
import {
    ManagersResourceFromJSON,
    ManagersResourceFromJSONTyped,
    ManagersResourceToJSON,
} from './';
import type { OpportunityType } from './';
import {
    OpportunityTypeFromJSON,
    OpportunityTypeFromJSONTyped,
    OpportunityTypeToJSON,
} from './';
import type { ProjectClientAction } from './';
import {
    ProjectClientActionFromJSON,
    ProjectClientActionFromJSONTyped,
    ProjectClientActionToJSON,
} from './';
import type { ProjectStatus } from './';
import {
    ProjectStatusFromJSON,
    ProjectStatusFromJSONTyped,
    ProjectStatusToJSON,
} from './';
import type { RenewalStatus } from './';
import {
    RenewalStatusFromJSON,
    RenewalStatusFromJSONTyped,
    RenewalStatusToJSON,
} from './';
import type { VerticalType } from './';
import {
    VerticalTypeFromJSON,
    VerticalTypeFromJSONTyped,
    VerticalTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientProjectResource
 */
export interface ClientProjectResource {
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    currentLotId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    correlationId: string;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof ClientProjectResource
     */
    status: ProjectStatus;
    /**
     * 
     * @type {Array<ProjectClientAction>}
     * @memberof ClientProjectResource
     */
    pendingActions: Array<ProjectClientAction>;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    subject: string;
    /**
     * 
     * @type {ClientOverviewResource}
     * @memberof ClientProjectResource
     */
    client: ClientOverviewResource;
    /**
     * 
     * @type {FreelancerOverviewResource}
     * @memberof ClientProjectResource
     */
    freelancer: FreelancerOverviewResource;
    /**
     * 
     * @type {ClientProjectType}
     * @memberof ClientProjectResource
     */
    type: ClientProjectType;
    /**
     * 
     * @type {Date}
     * @memberof ClientProjectResource
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientProjectResource
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClientProjectResource
     */
    sortDateForClient?: Date;
    /**
     * (deprecated) the purchase order number
     * @type {string}
     * @memberof ClientProjectResource
     */
    externalReference?: string;
    /**
     * the purchase order number
     * @type {string}
     * @memberof ClientProjectResource
     */
    purchaseOrderNumber?: string;
    /**
     * the optional registered budget
     * @type {number}
     * @memberof ClientProjectResource
     */
    purchaseOrderBudget?: number;
    /**
     * the optional registered internal id
     * @type {string}
     * @memberof ClientProjectResource
     */
    purchaseOrderId?: string;
    /**
     * the optional registered comment
     * @type {string}
     * @memberof ClientProjectResource
     */
    purchaseOrderComment?: string;
    /**
     * true when the client company requires a purchase order on its projects
     * @type {boolean}
     * @memberof ClientProjectResource
     */
    purchaseOrderMandatory: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    uniqueConversationId?: string;
    /**
     * 
     * @type {ContractType}
     * @memberof ClientProjectResource
     */
    contractType: ContractType;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    clientPaymentMode: ClientProjectResourceClientPaymentModeEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientProjectResource
     */
    currency: ClientProjectResourceCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof ClientProjectResource
     */
    totalEstimatedAmount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ClientProjectResource
     */
    paymentLimitDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientProjectResource
     */
    expenseBatchIdsToValidate?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientProjectResource
     */
    expenseProjectIdsToPay?: Array<string>;
    /**
     * 
     * @type {ManagersResource}
     * @memberof ClientProjectResource
     */
    managers: ManagersResource;
    /**
     * 
     * @type {VerticalType}
     * @memberof ClientProjectResource
     */
    verticalType?: VerticalType;
    /**
     * 
     * @type {OpportunityType}
     * @memberof ClientProjectResource
     */
    opportunityType?: OpportunityType;
    /**
     * 
     * @type {RenewalStatus}
     * @memberof ClientProjectResource
     */
    renewalStatus?: RenewalStatus;
    /**
     * Correlation id of the child renewal artifact (quote or mission). Present when renewalStatus is TO_APPROVE or RENEWED and a target exists.
     * @type {string}
     * @memberof ClientProjectResource
     */
    renewalTargetCorrelationId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClientProjectResource
     */
    plannedExpirationDate?: Date;
}


/**
 * @export
 */
export const ClientProjectResourceClientPaymentModeEnum = {
    PaymentByInvoice: 'PAYMENT_BY_INVOICE',
    Prepayment: 'PREPAYMENT'
} as const;
export type ClientProjectResourceClientPaymentModeEnum = typeof ClientProjectResourceClientPaymentModeEnum[keyof typeof ClientProjectResourceClientPaymentModeEnum];

/**
 * @export
 */
export const ClientProjectResourceCurrencyEnum = {
    Eur: 'EUR',
    Gbp: 'GBP',
    Usd: 'USD'
} as const;
export type ClientProjectResourceCurrencyEnum = typeof ClientProjectResourceCurrencyEnum[keyof typeof ClientProjectResourceCurrencyEnum];


/**
 * Check if a given object implements the ClientProjectResource interface.
 */
export function instanceOfClientProjectResource(value: object): value is ClientProjectResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('pendingActions' in value) || value['pendingActions'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('purchaseOrderMandatory' in value) || value['purchaseOrderMandatory'] === undefined) return false;
    if (!('contractType' in value) || value['contractType'] === undefined) return false;
    if (!('clientPaymentMode' in value) || value['clientPaymentMode'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('managers' in value) || value['managers'] === undefined) return false;
    return true;
}

export function ClientProjectResourceFromJSON(json: any): ClientProjectResource {
    return ClientProjectResourceFromJSONTyped(json, false);
}

export function ClientProjectResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientProjectResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'currentLotId': json['currentLotId'] == null ? undefined : json['currentLotId'],
        'correlationId': json['correlationId'],
        'status': ProjectStatusFromJSON(json['status']),
        'pendingActions': ((json['pendingActions'] as Array<any>).map(ProjectClientActionFromJSON)),
        'subject': json['subject'],
        'client': ClientOverviewResourceFromJSON(json['client']),
        'freelancer': FreelancerOverviewResourceFromJSON(json['freelancer']),
        'type': ClientProjectTypeFromJSON(json['type']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'sortDateForClient': json['sortDateForClient'] == null ? undefined : (new Date(json['sortDateForClient'])),
        'externalReference': json['externalReference'] == null ? undefined : json['externalReference'],
        'purchaseOrderNumber': json['purchaseOrderNumber'] == null ? undefined : json['purchaseOrderNumber'],
        'purchaseOrderBudget': json['purchaseOrderBudget'] == null ? undefined : json['purchaseOrderBudget'],
        'purchaseOrderId': json['purchaseOrderId'] == null ? undefined : json['purchaseOrderId'],
        'purchaseOrderComment': json['purchaseOrderComment'] == null ? undefined : json['purchaseOrderComment'],
        'purchaseOrderMandatory': json['purchaseOrderMandatory'],
        'uniqueConversationId': json['uniqueConversationId'] == null ? undefined : json['uniqueConversationId'],
        'contractType': ContractTypeFromJSON(json['contractType']),
        'clientPaymentMode': json['clientPaymentMode'],
        'currency': json['currency'],
        'totalEstimatedAmount': json['totalEstimatedAmount'] == null ? undefined : json['totalEstimatedAmount'],
        'paymentLimitDate': json['paymentLimitDate'] == null ? undefined : (new Date(json['paymentLimitDate'])),
        'expenseBatchIdsToValidate': json['expenseBatchIdsToValidate'] == null ? undefined : json['expenseBatchIdsToValidate'],
        'expenseProjectIdsToPay': json['expenseProjectIdsToPay'] == null ? undefined : json['expenseProjectIdsToPay'],
        'managers': ManagersResourceFromJSON(json['managers']),
        'verticalType': json['verticalType'] == null ? undefined : VerticalTypeFromJSON(json['verticalType']),
        'opportunityType': json['opportunityType'] == null ? undefined : OpportunityTypeFromJSON(json['opportunityType']),
        'renewalStatus': json['renewalStatus'] == null ? undefined : RenewalStatusFromJSON(json['renewalStatus']),
        'renewalTargetCorrelationId': json['renewalTargetCorrelationId'] == null ? undefined : json['renewalTargetCorrelationId'],
        'plannedExpirationDate': json['plannedExpirationDate'] == null ? undefined : (new Date(json['plannedExpirationDate'])),
    };
}

export function ClientProjectResourceToJSON(value?: ClientProjectResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'currentLotId': value['currentLotId'],
        'correlationId': value['correlationId'],
        'status': ProjectStatusToJSON(value['status']),
        'pendingActions': ((value['pendingActions'] as Array<any>).map((v) => ProjectClientActionToJSON(v))),
        'subject': value['subject'],
        'client': ClientOverviewResourceToJSON(value['client']),
        'freelancer': FreelancerOverviewResourceToJSON(value['freelancer']),
        'type': ClientProjectTypeToJSON(value['type']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'sortDateForClient': value['sortDateForClient'] == null ? undefined : ((value['sortDateForClient']).toISOString()),
        'externalReference': value['externalReference'],
        'purchaseOrderNumber': value['purchaseOrderNumber'],
        'purchaseOrderBudget': value['purchaseOrderBudget'],
        'purchaseOrderId': value['purchaseOrderId'],
        'purchaseOrderComment': value['purchaseOrderComment'],
        'purchaseOrderMandatory': value['purchaseOrderMandatory'],
        'uniqueConversationId': value['uniqueConversationId'],
        'contractType': ContractTypeToJSON(value['contractType']),
        'clientPaymentMode': value['clientPaymentMode'],
        'currency': value['currency'],
        'totalEstimatedAmount': value['totalEstimatedAmount'],
        'paymentLimitDate': value['paymentLimitDate'] == null ? undefined : ((value['paymentLimitDate']).toISOString()),
        'expenseBatchIdsToValidate': value['expenseBatchIdsToValidate'],
        'expenseProjectIdsToPay': value['expenseProjectIdsToPay'],
        'managers': ManagersResourceToJSON(value['managers']),
        'verticalType': VerticalTypeToJSON(value['verticalType']),
        'opportunityType': OpportunityTypeToJSON(value['opportunityType']),
        'renewalStatus': RenewalStatusToJSON(value['renewalStatus']),
        'renewalTargetCorrelationId': value['renewalTargetCorrelationId'],
        'plannedExpirationDate': value['plannedExpirationDate'] == null ? undefined : ((value['plannedExpirationDate']).toISOString()),
    };
}

